var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import logger from '../../../../core/utils/src/logger';
import { KeyCode } from '../../../../core/utils/src/dom';
import InputController from '../../../input/src/controllers/input-controller';
import { insertAt } from '../utils/strings';
import { isDigit, isCommand } from '../utils/keys';
import MaskFormat from '../utils/MaskFormat';
var MaskedInputController = /** @class */ (function (_super) {
    __extends(MaskedInputController, _super);
    function MaskedInputController(component, node) {
        var _this = _super.call(this, component, node) || this;
        _this.component = component;
        _this.node = node;
        _this._pasteListener = function (e) { return _this.pasteListener(e); };
        return _this;
    }
    MaskedInputController.prototype.addListeners = function () {
        _super.prototype.addListeners.call(this);
        this.node.addEventListener('paste', this._pasteListener);
    };
    MaskedInputController.prototype.removeListeners = function () {
        _super.prototype.removeListeners.call(this);
        this.node.removeEventListener('paste', this._pasteListener);
    };
    MaskedInputController.prototype.valueUpdateHandler = function (value) {
        var inputValue = this.format.tryAppendSeparator(value);
        if (!this.format.isValid(inputValue)) {
            inputValue = value;
        }
        _super.prototype.valueUpdateHandler.call(this, inputValue);
    };
    MaskedInputController.prototype.maskedValueAttributeChangeHandler = function (oldValue, newValue) {
        var toReturn;
        if (!this.format.isValid(newValue)) {
            logger.warn("Invalid string \"" + newValue + "\" provided to " + this.node.tagName + "#" + this.node.id);
            toReturn = oldValue;
        }
        else {
            toReturn = newValue;
        }
        this.valueAttributeChangeHandler(toReturn);
        return toReturn;
    };
    MaskedInputController.prototype.setFormat = function (format) {
        this.format = new MaskFormat(format);
    };
    MaskedInputController.prototype.reformat = function (format, value) {
        this.setFormat(format);
        return this.format.correctMinMaxValues(value);
    };
    MaskedInputController.prototype.setCursorPosition = function (position) {
        this.node.querySelector('input').setSelectionRange(position, position);
    };
    MaskedInputController.prototype.changeListener = function (value) {
        if (value === void 0) { value = this.component.getValue(); }
        if (value !== this.confirmedValue) {
            // Do not autocomplete if input is empty
            value = value ? this.format.autoComplete(value) : value;
            this.confirmedValue = value;
            this.component.notifyChange(value);
        }
    };
    MaskedInputController.prototype.keydownListener = function (event) {
        if (this.component.isReadOnly()) {
            return;
        }
        var inputElement = event.target;
        if (event.keyCode === KeyCode.backspace) {
            this.backspaceHandler(event, inputElement);
        }
        else if (event.keyCode === KeyCode.enter) {
            this.changeListener();
        }
        else if (isDigit(event.key) || this.format.isSeparator(event.key)) {
            this.keyHandler(event, inputElement);
        }
        else if (!isCommand(event)) {
            event.preventDefault();
        }
        this.sendKeyEvent(event);
    };
    MaskedInputController.prototype.pasteListener = function (event) {
        event.preventDefault();
        if (this.component.isReadOnly() || this.component.isDisabled()) {
            return;
        }
        var pastedValue = this.formatPastedText(event);
        if (pastedValue !== this.component.getValue()) {
            this.valueUpdateHandler(pastedValue);
        }
    };
    MaskedInputController.prototype.backspaceHandler = function (event, inputElement) {
        var _this = this;
        var cursorStart = inputElement.selectionStart;
        var cursorEnd = inputElement.selectionEnd;
        var value = this.component.getValue();
        var length = value.length;
        var singleBackspaceHandler = function () {
            var deletingSeparator = _this.format.isSegmentStart(cursorStart);
            var atEnd = cursorStart === length;
            var deletingDigitInMiddle = !atEnd && !deletingSeparator && cursorStart > 0;
            if (deletingSeparator) {
                if (atEnd) {
                    return {
                        value: value.slice(0, cursorStart - 2),
                        position: cursorStart - 2
                    };
                }
                return _this.format.deleteSeparator(_this.component.getValue(), cursorStart);
            }
            if (deletingDigitInMiddle) {
                return _this.format.deleteDigit(_this.component.getValue(), cursorStart);
            }
        };
        var groupBackspaceHandler = function () {
            var isCursorAtEnd = cursorEnd === length;
            if (!isCursorAtEnd) {
                return _this.format.replaceDigitsWithZeroes(_this.component.getValue(), cursorStart, cursorEnd);
            }
        };
        var result = cursorStart === cursorEnd ? singleBackspaceHandler() : groupBackspaceHandler();
        if (result) {
            event.preventDefault();
            this.valueUpdateHandler(result.value);
            this.setCursorPosition(result.position);
        }
    };
    MaskedInputController.prototype.keyHandler = function (event, inputElement) {
        event.preventDefault();
        var position = inputElement.selectionStart;
        var initialValue = this.component.getValue();
        var value = initialValue;
        var length = value.length;
        var isSeparator = this.format.isSeparator(event.key);
        // return if no more digits can be added at the end
        if (position === length && length === this.format.getMaxLength()) {
            return;
        }
        // if range is selected to the end, remove all of that selection first
        if (position !== length && inputElement.selectionEnd === length) {
            var sliceEnd = this.format.isCursorAtSeparator(position) ? position + 1 : position;
            value = value.slice(0, sliceEnd);
        }
        if (this.format.isCursorAtSeparator(position)) {
            this.component.overrideValue(value);
            this.setCursorPosition(position + 1);
            return;
        }
        if (isSeparator) {
            var result = this.format.handleSeparatorInput(value, position);
            if (result) {
                value = result.value;
                position = result.position;
            }
        }
        else {
            var result = this.processKey(value, position, event.key);
            value = result.value;
            position = result.position;
        }
        value = this.format.tryAppendSeparator(value);
        // Move cursor in front of separator if behind after overwriting a character
        if (this.format.isCursorAtSeparator(position)) {
            position++;
        }
        if (value !== initialValue) {
            this.valueUpdateHandler(value);
        }
        else {
            this.component.overrideValue(value);
        }
        this.setCursorPosition(position);
    };
    MaskedInputController.prototype.formatPastedText = function (event) {
        var inputElement = event.target;
        var cursorStart = inputElement.selectionStart;
        var cursorEnd = inputElement.selectionEnd;
        var text = (event.clipboardData || window.clipboardData).getData('text');
        var keyArr = text.trim().split('');
        var position = cursorStart;
        var value = this.component.getValue();
        // if a selection range captures the end of the current value
        // we replace it with the value in buffer even if the value in buffer is shorter
        if (cursorEnd > cursorStart && cursorEnd === value.length) {
            value = value.slice(0, cursorStart);
        }
        for (var _i = 0, keyArr_1 = keyArr; _i < keyArr_1.length; _i++) {
            var key = keyArr_1[_i];
            if (position >= this.format.getMaxLength()) {
                break;
            }
            if (this.format.isCursorAtSeparator(position)) {
                value = insertAt(value, this.format.separator, position, position + 1);
                position += 1;
                if (this.format.isSeparator(key)) {
                    continue;
                }
            }
            var newValue = insertAt(value, key, position, position + 1);
            if (!this.format.isValid(newValue)) {
                break;
            }
            var result = this.processKey(value, position, key);
            value = result.value;
            position = result.position;
        }
        return this.format.tryAppendSeparator(value);
    };
    MaskedInputController.prototype.processKey = function (text, position, key) {
        var isCursorAtEnd = position === text.length;
        var segmentValue = this.format.getSegmentValueWithAddition(position, text, key);
        var segmentMaxValue = this.format.getSegmentMaxValue(text, position);
        var segmentMinValue = this.format.getSegmentMinValue(text, position);
        var firstDigitGreater = parseInt(key, 10) > parseInt(segmentMaxValue.toFixed()[0], 10);
        var isValidPosition = isCursorAtEnd || segmentValue.toFixed().length === 1;
        var exceedsMaxAtSegmentStart = this.format.isSegmentStart(position) && isValidPosition && firstDigitGreater;
        var offset = 0;
        var value = text;
        if (exceedsMaxAtSegmentStart) {
            // 22:| => Enter '9' => 22:09|
            // |1 => Enter '9' => 09|
            value = insertAt(value, "0" + key, position, position + 2);
            offset = 2;
        }
        else if (segmentValue > segmentMaxValue && this.format.isSegmentStart(position)) {
            // 22:|22 => Enter '9' => 22:59|
            value = insertAt(value, segmentMaxValue.toFixed(), position, position + segmentMaxValue.toFixed().length);
            offset = segmentMaxValue.toFixed().length;
        }
        else if (segmentValue > segmentMaxValue) {
            // 2|2:22 => Enter '9' => 23:|22
            value = insertAt(value, segmentMaxValue.toFixed(), position - 1, position + 1);
            offset = 1;
        }
        else if (segmentValue < segmentMinValue && !this.format.isSegmentStart(position)) {
            // 0| => enter '0' => 01:
            value = insertAt(value, segmentMinValue.toFixed(), position, position + 1);
            offset = 1;
        }
        else {
            // 22:| => Enter '5' => 23:5|
            value = insertAt(value, key, position, position + 1);
            offset = 1;
        }
        return {
            value: value,
            position: position + offset
        };
    };
    return MaskedInputController;
}(InputController));
export default MaskedInputController;
//# sourceMappingURL=masked-input-controller.js.map